<!-- Hero Start -->
<section class="home-slider position-relative" id="home">
    <ngb-carousel [showNavigationIndicators]="showNavigationIndicators">
        <ng-template ngbSlide>
            <div class="align-items-center" style="background-size:cover; background-image:url('assets/3r/cover/people-2557396_640.jpg');">
                <div class="bg-overlay"></div>
                <div class="container">
                    <div class="row justify-content-center">
                        <div class="col-lg-12 text-center">
                            <div class="title-heading mt-4">
                                <!--                                <h6 class="text-light para-dark animated fadeInDownBig animation-delay-1">Private office and-->
                                <!--                                    Co-working space for <span class="text-success">$19</span></h6>-->
                                <h1 class="heading mb-3 text-white title-dark animated fadeInUpBig animation-delay-3">Excellence through learning</h1>
                            </div>
                        </div>
                        <!--end col-->
                    </div>
                    <!--end row-->
                </div>
                <!--end container-->
            </div>
            <!--end carousel item-->
        </ng-template>
        <ng-template ngbSlide>
            <div class="align-items-center" style="background-size:cover; background-image:url('assets/3r/cover/medium-shot-woman-taking-notes.jpg');">
                <div class="bg-overlay"></div>
                <div class="container">
                    <div class="row justify-content-center">
                        <div class="col-lg-12 text-center">
                            <div class="title-heading mt-4">
                                <!--                                <h6 class="text-light para-dark animated fadeInDownBig animation-delay-1">The Best Coworking in The-->
                                <!--                                    City</h6>-->
                                <h1 class="heading mb-3 text-white title-dark animated fadeInUpBig animation-delay-3">Everyone a learner everyday</h1>
                                <p class="para-desc mx-auto text-light para-dark animated fadeInUpBig animation-delay-7">Launch your
                                    campaign and benefit from our expertise on designing and managing conversion centered bootstrap4
                                    html page.</p>

                                <!--end subscribe form-->
                            </div>
                        </div>
                        <!--end col-->
                    </div>
                    <!--end row-->
                </div>
                <!--end container-->
            </div>
            <!--end carousel item-->
        </ng-template>
        <ng-template ngbSlide>
            <div class="align-items-center" style="background-size:cover; background-image:url('assets/3r/cover/students-1807505_640.jpg');">
                <div class="bg-overlay"></div>
                <div class="container">
                    <div class="row justify-content-center">
                        <div class="col-lg-12 text-center">
                            <div class="title-heading mt-4">
                                <!--                                <h6 class="text-light para-dark animated fadeInDownBig animation-delay-1">Our Space for You</h6>-->
                                <h1 class="heading mb-3 text-white title-dark animated fadeInUpBig animation-delay-3">Education – Your Door To The Future</h1>
                                <p class="para-desc mx-auto text-light para-dark animated fadeInUpBig animation-delay-7">Launch your
                                    campaign and benefit from our expertise on designing and managing conversion centered bootstrap4
                                    html page.</p>
                            </div>
                        </div>
                        <!--end col-->
                    </div>
                    <!--end row-->
                </div>
                <!--end container-->
            </div>
            <!--end carousel item-->
        </ng-template>
    </ngb-carousel>

    <!--end carousel inner-->

    <!-- </div> -->
</section>
<div class="container mt-100 mt-60">
    <div class="row mb-5">
        <div class="col-lg-4 col-md-6 mt-4 pt-2" *ngFor="let d of dest">
            <div class="card blog rounded border-0 shadow">
                <div class="position-relative">
                    <img src="data:image/png;base64,{{d.image}}" class="card-img-top rounded-top" alt="...">
                    <div class="overlay rounded-top bg-dark"></div>
                </div>
                <div class="card-body content">
                    <h5><a href="javascript:void(0)" class="card-title title text-dark">{{d.name}}</a>
                    </h5>
                    <p class="text-muted">{{d.description | slice:0:150}} ...</p>
                    <button (click)="booking(d)" class="btn-sm btn  btn-primary mr-3">See more</button>
                </div>

<!--                <div class="author">-->
<!--                    <small class="text-light user d-block"><i class="mdi mdi-account"></i> Calvin Carlo</small>-->
<!--                    <small class="text-light date"><i class="mdi mdi-calendar-check"></i> 13th August, 2019</small>-->
<!--                </div>-->
            </div>
        </div>
        <!--end col-->
    </div>
</div>
